import { sharedPages } from "Views/Shared";
import { controllerFromRouteTable } from "Views/Tools";
import { AccreditationAndFacilities } from "./AccreditationAndFacilities";
import { AddAdditionalInsured } from "./AddAdditionalInsured";
import { AdditionalInsureds } from "./AdditionalInsureds";
import { AdditionalUnderwritingRequired } from "./AdditionalUnderwritingRequired";
import { ApplicantInformation } from "./ApplicantInformation";
import { CoverageInformation } from "./CoverageInformation";
import { PolicyRenewalNoLongerAvailableNotification } from "./Notifications/PolicyRenewalNoLongerAvailable";
import { OptionalCoverages } from "./OptionalCoverages";
import { PurchasePolicy } from "./PurchasePolicy";
import { RequirementsChecklist } from "./RequirementsChecklist";
import { ShowQuote } from "./ShowQuote";
import { ThankYou } from "./ThankYou";
import { UnderwritingInformation } from "./UnderwritingInformation";
import { UpdateCoverageDates } from "./UpdateCoverageDates";
import { ManageCertificates } from "./ManageCertificates";

export const FitnessInstructorController = controllerFromRouteTable({
  ...sharedPages,
  ApplicantInformation,
  AccreditationAndFacilities,
  UnderwritingInformation,
  CoverageInformation,
  OptionalCoverages,
  RequirementsChecklist,
  AdditionalInsureds,
  AddAdditionalInsured,
  AdditionalUnderwritingRequired,
  ShowQuote,
  PurchasePolicy,
  ManageCertificates,

  ThankYou,
  UpdateCoverageDates,
  PolicyRenewalNoLongerAvailableNotification,
});
